<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutTeamHeader',
  inject: ['wp']
}
</script>
